









import { Component, Vue, Prop } from 'vue-property-decorator';
@Component({
  name: 'checkbox-label',
})
export default class CheckboxLabel extends Vue {
  @Prop({ type: String, required: true }) text!: string;
  @Prop({ type: String, required: true }) keyValue!: string;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }

  private get preparedLabelArray(): Array<{ type: string; content?: string }> {
    const labelRegex = new RegExp(`(${this.keyValue})`);
    const labelArray = this.text.split(labelRegex);
    return labelArray.map(element => {
      if (element === this.keyValue) {
        return {
          type: 'slot',
        };
      }
      return {
        type: 'text',
        content: element,
      };
    });
  }
}
